import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SHORTCUTS} from '../../configs/tastenbelegung.config';

@Component({
  selector: 'barrierefreiheitTastenbelegungAnsicht',
  templateUrl: './barrierefreiheitTastenbelegungAnsicht.component.html',
  styleUrls: ['./barrierefreiheitTastenbelegungAnsicht.component.css'],
})

export class BarrierefreiheitTastenbelegungAnsichtComponent implements OnInit, OnDestroy {

  public shortcuts = SHORTCUTS

  constructor(
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}
